import React, { useState, useRef } from 'react'
import { getUsageCountReport } from '../../services/transactions'
import { Typography } from '@mui/material'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'jspdf-autotable'
import LoadingScreen from '../../utils/LoadingScreen'

export default function UsageReport() {
  const [usageData, setUsageData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [date, setDate] = useState(moment().format('YYYY-MM-DD HH:mm:ss'))
  const tableRef = useRef(null)

  const handleUsageReport = async () => {
    // console.log(
    //   'Date  === > ',
    //   new Date(date).toISOString().split('T')[0],
    //   '==',
    //   new Date().toISOString().split('T')[0]
    // )
    if (new Date(date) > new Date()) {
      toast.error('Check selected Date')
      return
    }
    setIsLoading(true)

    const response = await getUsageCountReport(date)

    if (response['status'] === 'success') {
      setIsLoading(false)
      toast.success('Report is fetched')
      setUsageData(response?.data)
    } else {
      toast.error(response['error'])
      setIsLoading(false)
    }
  }

  const groupByUserAndCalculateTotals = () => {
    if (!usageData || usageData.length === 0) return { grouped: {}, groupOrder: [], grandTotals: {} };

    const grouped = {};
    const groupOrder = [];
    const uniqueClients = new Set();
    let totalLineItems = 0;
    let totalQty = 0;
    let totalScanCount = 0;
    let totalSuccess = 0;
    let totalFail = 0;

    usageData.forEach((item) => {
      const clientName = item?.client_name || 'N/A';
      const remark = item?.remark || 'N/A';
      const groupKey = `${clientName}___${remark}`;
      const scanCount = item?.scan_count || 0;
      const fail = item?.fail || 0;
      const success = scanCount - fail;
      const qty = item?.quantity || item?.scan_count || 0;

      uniqueClients.add(clientName);
      totalLineItems += 1; // Each row is a line item
      totalQty += qty;

      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          clientName,
          remark,
          items: [],
          scanCount: 0,
          success: 0,
          fail: 0,
        };
        groupOrder.push(groupKey);
      }

      grouped[groupKey].items.push(item);
      grouped[groupKey].scanCount += scanCount;
      grouped[groupKey].success += success;
      grouped[groupKey].fail += fail;

      totalScanCount += scanCount;
      totalSuccess += success;
      totalFail += fail;
    });

    return {
      grouped,
      groupOrder,
      grandTotals: {
        totalScanCount,
        totalSuccess,
        totalFail,
        uniqueClientCount: uniqueClients.size,
        totalLineItems,
        totalQty,
      },
    };
  }

  const tableToCSV = () => {
    let csv_data = []

    let rows = document.getElementsByTagName('tr')

    for (let i = 0; i < rows.length; i++) {
      let cols = rows[i].querySelectorAll('td,th')

      let csvrow = []
      for (let j = 0; j < cols.length; j++) {
        csvrow.push(cols[j].innerHTML)
      }

      csv_data.push(csvrow.join(','))
    }

    csv_data = csv_data.join('\n')

    let CSVFile = new Blob([csv_data], {
      type: 'text/csv',
    })

    let temp_link = document.createElement('a')

    temp_link.download = `Usage report - ${date}.csv`
    let url = window.URL.createObjectURL(CSVFile)
    temp_link.href = url

    temp_link.style.display = 'none'
    document.body.appendChild(temp_link)

    temp_link.click()
    document.body.removeChild(temp_link)
  }

  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      {/* {JSON.stringify(usageData)} */}
      {isLoading && (
        <LoadingScreen
          loading={isLoading}
          message={'Loading usage report, Please wait ...'}
        />
      )}
      <div className="container mb-5 mt-1" style={{ width: 700 }}>
        <Typography
          variant="h5"
          style={{ textAlign: 'center', marginBottom: 20 }}
        >
          {new Date(date).toISOString().split('T')[0].toString() ===
          new Date().toISOString().split('T')[0].toString() ? (
            <>Todays Usage Report</>
          ) : (
            <>Usage Report</>
          )}
        </Typography>

        <div
          className="row "
          style={{
            display: 'flex',

            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="col ">
            <div
              style={{
                width: 400,
              }}
            >
              <label>Select Date</label>
              <input
                type="date"
                // max={new Date()}
                defaultValue={moment().format('YYYY-MM-DD')}
                onChange={(e) => {
                  setDate(moment(e.target.value).format('YYYY-MM-DD'))
                }}
                className="form-control"
              />
            </div>
          </div>

          <div className="col mt-4 ">
            <button className="btn btn-success" onClick={handleUsageReport}>
              Create Usage Report
            </button>
          </div>
        </div>
      </div>
      <hr />

      <div
        style={{
          marginTop: 30,
          marginLeft: 100,
          marginRight: 100,
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div>
          {usageData?.length > 0 ? (
            <div>
              <button className="btn btn-primary" onClick={tableToCSV}>
                Download Usage Report
              </button>
            </div>
          ) : (
            ''
          )}
        </div>

        {usageData?.length > 0 ? (
          <div>
            <table
              className="table table-striped border"
              style={{
                marginTop: 30,
              }}
              id="100"
              ref={tableRef}
            >
              <thead>
                <tr>
                  <th>Scan count</th>
                  <th>Success</th>
                  <th>Fail</th>
                  <th>Login Time</th>
                  <th>User Name</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const { grouped, groupOrder, grandTotals } = groupByUserAndCalculateTotals();
                  let rowsContent = [];

                  groupOrder.forEach((groupKey) => {
                    const group = grouped[groupKey];
                    // Add each item row
                    group.items.forEach((item, index) => {
                      rowsContent.push(
                        <tr key={`${groupKey}-${index}`}>
                          <td>{item?.scan_count}</td>
                          <td>{item?.scan_count - item?.fail}</td>
                          <td>{item?.fail}</td>
                          <td>{item?.login_time}</td>
                          <td>{item?.user_name}</td>
                        </tr>
                      );
                    });

                    // Add subtotal row for this group
                    rowsContent.push(
                      <tr
                        key={`${groupKey}-subtotal`}
                        style={{
                          backgroundColor: '#f0f0f0',
                          fontWeight: 'bold',
                        }}
                      >
                        <td>{group.scanCount}</td>
                        <td>{group.success}</td>
                        <td>{group.fail}</td>
                        <td>{group.remark}</td>
                        <td>{group.clientName}</td>
                      </tr>
                    );
                  });

                  // Add grand total row
                  rowsContent.push(
                    <tr
                      key="grand-total"
                      style={{
                        backgroundColor: '#d3d3d3',
                        fontWeight: 'bold',
                        fontSize: '16px',
                      }}
                    >
                      <td>{grandTotals.totalLineItems}</td>
                      <td>-</td>
                      <td>-</td>
                      <td>Grand Total</td>
                      <td>{grandTotals.uniqueClientCount} Clients | Qty: {grandTotals.totalQty}</td>
                    </tr>
                  );

                  return rowsContent;
                })()}
              </tbody>
            </table>
            {usageData?.length > 0 && (() => {
              const { grandTotals } = groupByUserAndCalculateTotals();
              return (
                <div
                  style={{
                    marginTop: 30,
                    padding: 20,
                    backgroundColor: '#f9f9f9',
                    border: '2px solid #333',
                    borderRadius: 8,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 15 }}>
                    Summary
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-around', gap: 20 }}>
                    <div>
                      <Typography variant="body1" style={{ color: '#666' }}>
                        Total Line Items
                      </Typography>
                      <Typography variant="h5" style={{ fontWeight: 'bold', color: '#0066cc' }}>
                        {grandTotals.totalLineItems}
                      </Typography>
                    </div>
                    <div>
                      <Typography variant="body1" style={{ color: '#666' }}>
                        Total Quantity
                      </Typography>
                      <Typography variant="h5" style={{ fontWeight: 'bold', color: '#0066cc' }}>
                        {grandTotals.totalQty}
                      </Typography>
                    </div>
                    <div>
                      <Typography variant="body1" style={{ color: '#666' }}>
                        Total Clients
                      </Typography>
                      <Typography variant="h5" style={{ fontWeight: 'bold', color: '#0066cc' }}>
                        {grandTotals.uniqueClientCount}
                      </Typography>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        ) : (
          <p className="font-weight-bold text-danger">
            Report data not yet available
          </p>
        )}
      </div>
    </div>
  )
}
